import React, { useState, useEffect, useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Icon } from '@iconify/react'
import { useSnackbar } from 'notistack5'
import menu2Fill from '@iconify/icons-eva/menu-2-fill'
import { alpha, styled } from '@material-ui/core/styles'
import { Box, Stack, AppBar, Toolbar, IconButton, Typography, Container } from '@material-ui/core'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { MHidden } from '../../components/@material-extend'
//
import MenuIcon from '@mui/icons-material/Menu';
// import NotificationsPopover from './NotificationsPopover'
import storage from 'utils/storage'
import { SocketContext } from 'utils/context/socket'
import Logo from 'components/Logo'
import { getBreadcrumbInfo } from 'utils/breadcrumbUtils'
// import {UsersContext} from 'utils/context/users'
const DRAWER_WIDTH = 0
const APPBAR_MOBILE = 40
const APPBAR_DESKTOP = 92

// Detect mobile platforms for proper spacing
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isAndroid = /Android/i.test(navigator.userAgent);

const DashboardNavbar = ({ open, onOpenSidebar, onOpenAdminSidebar, _data }) => {
  const navigation = useNavigate()
  const location = useLocation()
  const socket = useContext(SocketContext)
  const { enqueueSnackbar } = useSnackbar()
  // const {users, setUsers} = useContext(UsersContext)
  const [data, setData] = useState({
    users: [],
    employee: [],
    loading: false,
    online: 0,
  })

  const [isHeaderVisible, setIsHeaderVisible] = useState(false);
  const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
    // Completely transparent background for admin users, gradient for employees
    background: data.users.role === 1 || data.users.role >= 3 ? 
      'transparent' : 
      'linear-gradient(135deg, #2FB7DE 0%, #23A6DC 50%, #1F99DC 100%)',
    // For admin roles, let the header scroll with the page; for employees keep it fixed
    position: (data.users.role === 1 || data.users.role >= 3) ? 'relative' : 'fixed',
    color: data.users.role === 1 || data.users.role >= 3 ? '#333' : 'white', // Dark text for admin, white for employee
    boxShadow: data.users.role === 1 || data.users.role >= 3 ? 
      'none' : 
      '0 2px 10px rgba(47, 183, 222, 0.3)',
    backdropFilter: data.users.role === 1 || data.users.role >= 3 ? 
      'none' : 
      'blur(10px)',
    // Reduced height and added mobile padding
    height: isMobile ? '90px' : '100px',
    width: '100%',
    minHeight: APPBAR_MOBILE,
    // Add safe area padding for mobile devices
    paddingTop: isMobile ? (isIOS ? '44px' : '24px') : '0px',
    [theme.breakpoints.up('lg')]: {
      minHeight: APPBAR_DESKTOP,
      padding: theme.spacing(0, 5),
    },
  }))

  const load = async () => {
    setData((p) => ({ ...p, loading: true }))
    const local_user = await storage.getUser()
    if (!local_user) return;
    const user = JSON.parse(local_user)
    let { _id, role } = user
    if (socket && (role === 1 || role === 3)) {
      socket.emit('get_users', { _id })
    }
    return setData((p) => ({ ...p, users: user, loading: false }))
  }

  const handleNavigateDashboard = () => {
    onOpenSidebar()
    navigation('/dashboard/app')
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

/*  useEffect(() => {
    socket.on('notification', async (notif) => {
      const local_user = await storage.getUser()
      if (!local_user) return;
      const user = JSON.parse(local_user)
      if (user.role === 1 || user.role === 4) {
        let { _id } = user
        socket.emit('get_users', { _id })
        enqueueSnackbar(notif?.description, {
          variant: 'info',
        })
      }
    })

    socket.on('receive_status', async (notif) => {
      const local_user = await storage.getUser()
      if (!local_user) return;
      const user = JSON.parse(local_user)
      if (user.role === 1 || user.role === 4) {
        let { _id } = user
        socket.emit('get_users', { _id })
        enqueueSnackbar(`${notif?.user} - ${notif?.status}`, {
          variant: 'info',
        })
      }
    })

    socket.on('users', async (users) => {
      if (!users) return console.log('error fetching users')

      const local_user = await storage.getUser()
      if (!local_user) return console.log('error current user')

      const index = users.findIndex((user) => user.uuid === user._id)
      if (index !== -1) {
        return users.splice(index, 1)[0]
      }

      return setData((p) => ({ ...p, online: users.length }))
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, enqueueSnackbar])*/

  // Check if current page is QR scan page
  const isQRScanPage = location.pathname === '/stores/biometric'

  return (
      <ToolbarStyle sx={{borderRadius: open ? '0 0 0 50px' : '0 0 50px 50px'}}>
        
        {/* Hamburger menu for QR scan page - positioned on the left */}
        {(data.users.role === 1 || data.users.role >= 3) && (
          <IconButton
            onClick={onOpenAdminSidebar}
            sx={{
              position: 'absolute',
              left: 16,
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 1000,
              color: 'black',
              '&:hover': {
                backgroundColor: 'rgba(47, 183, 222, 0.1)'
              },
              backgroundColor: 'rgba(47, 183, 222, 0.05)',
              borderRadius: '12px',
            }}
          >
            <MenuIcon sx={{ color: '#1F99DC', fontSize: 30 }} />
          </IconButton>
        )}
        {(location.pathname === '/dashboard/app/profile' || location.pathname === '/dashboard/app/my-company' || location.pathname === '/dashboard/app/required-documents' || location.pathname === '/dashboard/app/my-history') && (
          <IconButton
            onClick={() => handleNavigateDashboard()}
            sx={{
              color: 'text.primary',
              position: 'absolute',
              zIndex: 1000,
              mb: {xs: 6, sm: 0}
            }}
          >
            <ChevronLeftIcon sx={{color: 'white'}} fontSize='large' />
          </IconButton>
        )}
          <>
            {data.users.role === 0 || isQRScanPage
              ? 
                  <>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: 'calc(100% - 80px)', // Leave space for hamburger button on the right
                    justifyContent: 'center',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 80, // Leave 80px space on the right for hamburger button
                    bottom: 0,
                    zIndex: 1, // Low z-index so hamburger button can be above
                  }}>
                      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <img src="/favicon/header-logo.png" alt="Dashboard Logo" style={{width: '65%', height: '65%'}} />
                        <Typography
                          variant="p" 
                          sx={{
                            fontSize: '0.80rem',
                            color: 'white',
                            mb: 1
                          }}
                        >
                          App Version: {process.env.REACT_APP_VERSION}
                        </Typography>
                      </Box>
                  </Box>
                  </>
              : 
                ''
            }
          </>
        {/* {(data.users.role === 1 || data.users.role >= 3) && (
          <MHidden width="lgUp">
            <IconButton onClick={onOpenAdminSidebar} sx={{ mr: 1, mb: { xs: 4, sm: 0 }, color: 'text.primary' }}>
              <Icon icon={menu2Fill} /> 
            </IconButton>
          </MHidden>
        )} */}
        
        {/* Breadcrumb for Admin Users */}
        {(data.users.role === 1 || data.users.role >= 3) && (
          <>
          <Box sx={{ 
            flexGrow: 1, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'flex-start',
            ml: { xs: 8, sm: 12, md: 20, lg: 35 }, // Responsive left margin
            mr: { xs: 2, sm: 4 }, // Right margin to prevent overflow
            mb: { xs: 3, sm: 0 },
            overflow: 'hidden' // Prevent text overflow
          }}>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'row', sm: 'column' }, // Stack vertically on mobile, horizontally on larger screens
              alignItems: { xs: 'center', sm: 'flex-start' },
              justifyContent: 'flex-start',
              width: '100%',
              overflow: 'hidden'
            }}>
              {/* Mobile layout: Show only page name with category as subtitle */}
              {/* <Box sx={{ 
                display: { xs: 'flex', sm: 'none' },
                flexDirection: 'column',
                width: '100%',
                overflow: 'hidden'
              }}>
                <Typography variant="caption" sx={{ 
                  color: '#666',
                  fontWeight: 400,
                  fontSize: '0.75rem',
                  lineHeight: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '100%'
                }}>
                  {(() => {
                    const breadcrumbInfo = getBreadcrumbInfo(location.pathname);
                    return breadcrumbInfo.category;
                  })()}
                </Typography>
              </Box> */}
              {location.pathname !== '/stores/biometric' && (
                  <>
                {/* Desktop layout: Show both category and full breadcrumb */}
              <Box sx={{ 
                display: { xs: 'none', sm: 'flex' },
                flexDirection: 'column',
                width: '100%'
              }}>
                <Typography variant="h6" sx={{ 
                  color: '#555',
                  fontWeight: 500,
                  fontSize: { sm: '0.9rem', md: '1rem', lg: '1.1rem' },
                  lineHeight: 1.2,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '100%'
                }}>
                  {(() => {
                    const breadcrumbInfo = getBreadcrumbInfo(location.pathname);
                    return `${breadcrumbInfo.category} › ${breadcrumbInfo.page}`;
                  })()}
                </Typography>
              </Box>
              </>
              )}
            </Box>
          </Box>
          {location.pathname !== '/stores/biometric' && (
          <Box sx={{ flexGrow: 1 }} >
            <Typography variant="h4" gutterBottom sx={{ 
            fontWeight: 'bold',
            color: '#1F99DC',
            fontSize: '1rem',
            mr: { xs: 2, sm: 2, md: 20, lg: 35 },
            mb: { xs: 3, sm: 0 },
          }}>
            {(() => {
              const breadcrumbInfo = getBreadcrumbInfo(location.pathname);
              return `${breadcrumbInfo.page}`;
            })()}
          </Typography>
          </Box>
          )}
          </>
        )}
        
        {!(data.users.role === 1 || data.users.role >= 3) && <Box sx={{ flexGrow: 1 }} />}
        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }} mb={isMobile ? 4 : 0}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={onOpenSidebar}
            sx={{
              position: (data.users.role === 1 || data.users.role >= 3) ? 'fixed' : 'static',
              top: (data.users.role === 1 || data.users.role >= 3)
                ? (isMobile ? (isIOS ? 56 : 24) : 16)
                : 'auto',
              right: (data.users.role === 1 || data.users.role >= 3) ? 16 : 'auto',
              zIndex: (data.users.role === 1 || data.users.role >= 3) ? 1300 : 10,
              '&:hover': {
                backgroundColor: data.users.role === 1 || data.users.role >= 3 ? 
                  'rgba(47, 183, 222, 0.1)' : 'rgba(255, 255, 255, 0.1)'
              },
              mr: 1,
              backgroundColor: data.users.role === 1 || data.users.role >= 3 ? 
                'rgba(47, 183, 222, 0.05)' : 'rgba(255, 255, 255, 0.05)',
              borderRadius: '12px',
            }}
          >
            <MenuIcon sx={{ 
              color: data.users.role === 1 || data.users.role >= 3 ? '#1F99DC' : 'white', 
              fontSize: 30 
            }} />
          </IconButton>
        </Stack>
      </ToolbarStyle>
  )
}

export default DashboardNavbar

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
}
